import PropTypes from 'prop-types';
import React from 'react';
import { containerApp } from '../../../../main';
import Spinner from './spinner';

const Loading = ({ className }) => (
  <div className={className}>
    <div className="c-table-card u-table-layout-fixed">
      <div className="c-table-card__row">
        <div className="c-table-card__cell u-2/10" />
        <div className="c-table-card__cell u-6/10">
          <div className="c-loader">
            <Spinner />
          </div>
        </div>
        <div className="c-table-card__cell u-2/10" />
      </div>
    </div>
  </div>
);

Loading.propTypes = {
  className: PropTypes.string,
};

Loading.defaultProps = {
  className: 'table',
};

export default containerApp.hideForContainerApp(Loading);
